<template>
  <main role="main">
    <div class="page-bn s7-1bn">
    <a href="mailto:crcb@mgt.ncu.edu.tw"  class="mail-box">
      <h3>{{ $t('CONTACT.EMAIL') }}</h3>
      <p>crcb@mgt.ncu.edu.tw</p>
      <i></i>
    </a>
    <a href="https://www.google.com/maps/search/%E6%A1%83%E5%9C%92%E5%B8%82%E4%B8%AD%E5%A3%A2%E5%8D%80%E4%B8%AD%E5%A4%A7%E8%B7%AF300+%E8%99%9F+%E5%BF%97%E5%B8%8C%E9%A4%A8+8+%E6%A8%93/@24.9695712,121.1933047,18z/data=!3m1!4b1" target="_blank" class="address-box" :class="{'address-box-en':lang=='en'}">
      <h3>{{ $t('CONTACT.ADDRESS.TITLE') }}</h3>
      <p v-html="$t('CONTACT.ADDRESS.CONTENT')"></p>
      <i></i>
    </a>
    
  </div>
  <div class="page-conus-con">
    <div class="title-box">
      <h2>Contact Us !</h2>
      <p v-html="$t('CONTACT.DESC')"></p>
    </div>
    <div>
       
      <form action="input-con">
        <p class="required">* {{ $t('CONTACT.REQUIRED') }}</p>
        <ul>
          <li>
            <div>
              <div class="input-box" :class="{'input-box-en':lang=='en'}">
                <p><span>*</span>{{ $t('CONTACT.NAME') }}</p><input id="name" type="text" name="usrname" :placeholder="$t('CONTACT.NAMEMSG')" v-model="item.name">
              </div>
              <p class="remind name-p" style="font-size: 0px;">{{$t('CONTACT.NAMEMSG')}}</p>
            </div>
            <div>
              <div class="input-box" :class="{'input-box-en':lang=='en'}">
                <p>{{$t('CONTACT.COMPANY')}}</p><input type="text" name="company" :placeholder="$t('CONTACT.COMPANYMSG')" v-model="item.company">
              </div>
              <p class="remind " style="font-size: 0px;">{{$t('CONTACT.COMPANYMSG')}}</p>
            </div>
            <div>
              <div class="input-box" :class="{'input-box-en':lang=='en'}">
                <p><span>*</span>{{$t('CONTACT.PHONE')}}</p><input id="phone" type="text" name="phone" :placeholder="$t('CONTACT.PHONEMSG')" v-model="item.phone">
              </div>
              <p class="remind phone-p" style="font-size: 0px;">
                <span class="remind" v-if="!phone_p">{{$t('CONTACT.PHONEMSG')}}</span>
                <span class="remind" v-if="!phone_e">{{$t('CONTACT.PHONEERROR')}}</span>
              </p>
            </div>
            <div>
              <div class="input-box" :class="{'input-box-en':lang=='en'}">
                <p><span>*</span>{{$t('CONTACT.EMAILFIELD')}}</p>
                <input id="email" type="email" name="email" :placeholder="$t('CONTACT.EMAILFIELDMSG')" v-model="item.email">
              </div>
              <p class="remind email-p" style="font-size: 14px;">
                <span class="remind" v-if="!email_p">{{$t('CONTACT.EMAILFIELDMSG')}}</span>
                <span class="remind" v-if="!email_e">{{$t('CONTACT.EMAILERROR')}}</span>
              </p>
            </div>
          </li>
          <li>
            <div>
              <div class="input-box" :class="{'input-box-en':lang=='en'}">
                <p><span>*</span>{{$t('CONTACT.SUBJECT')}}</p><input id="title" type="text" name="title" :placeholder="$t('CONTACT.SUBJECTMSG')" v-model="item.title">
              </div>
              <p class="remind title-p" style="font-size: 0px;">{{$t('CONTACT.SUBJECTMSG')}}</p>
            </div>
            <div>
              <div :class="{'input-box-en':lang=='en'}"> 
                <p class="con-content-txt"><span>*</span>{{$t('CONTACT.CONTENT')}}</p>
                <textarea  id="desc" rows="10" v-model="item.desc" ></textarea>
              </div>
              <p class="remind con-p" style="font-size: 0px;">{{$t('CONTACT.CONTENTMSG')}}</p>
            </div>
            <div>
              <div class="input-box code" :class="{'input-box-en':lang=='en'}">
                <div>
                    <p><span>*</span>{{$t('CONTACT.CAPTCHA')}}</p>
                    <input id="code" type="text" name="code" style="text-transform:uppercase" :placeholder="lang!='en' ? $t('CONTACT.CAPTCHAMSG'):''" v-model="codevalue">
                </div>
                <div class="reload-box">
                  <input type="button" class="btn-lpicma mt-2"  v-model="checkCode"/> 
                  <a class="reload" @click="createCode()"><i></i></a>
                </div>
                
              </div>
              <p class="remind code-p" style="font-size: 0px;">{{checkcodeMsg}}</p>
            </div>
          </li>
        </ul>
       
        <button id="button" class="submit-btn" type="button" v-on:click="Post" >{{$t('CONTACT.SUBMIT')}}</button>
      </form>
      
    </div>
  </div>
    <IndexFooter></IndexFooter>
</main>
</template>
<script>
import moment from 'moment'
import {fb, db } from '../../firebase'
export default {
    name: 'Contact',
    data () {
        return {
            checkcodeMsg:'',
            checkCode:'',
            codevalue:'',
            item:{
                name:'',
                company:'',
                phone:'',
                email:'',
                title:'',
                desc:'',
                date:moment().format("YYYY-MM-DD HH:mm:ss"),
            },
            phone_p:true,
            phone_e:true,
            email_p:true,
            email_e:true,
            lang:''
        }
    },
    mounted () {
      this.lang = localStorage.getItem('language') || 'zh';
      this.createCode();
    },
    watch:{
      'item.phone':function(val){
        var numReg = /^[0-9]*$/;
        var numRe = new RegExp(numReg)
        if (!numRe.test(val)) this.phone_e = false;
        else this.phone_e = true;
      },
      'item.email':function(val){
        var emailReg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
        var emailRe = new RegExp(emailReg)
        if (!emailRe.test(val) && val != '') this.email_e = false;
        else this.email_e = true;
      }
    },
    methods: {
        Post() {
            var vm = this;
            var check = true;

            if ( this.item.name == '' ) {
                $(".name-p").css("font-size","14px");
                check = false;
            } else  $(".name-p").css("font-size","0px");
            if ( this.item.phone == '' ) {
                $(".phone-p").css("font-size","14px");
                this.phone_p = false;
                check = false;
            } else {
              $(".phone-p").css("font-size","0px");
               this.phone_p = true;
            }
            if ( this.item.email == '' ) {
                $(".email-p").css("font-size","14px");
                this.email_p = false;
                check = false;
            } else {
              $(".email-p").css("font-size","0px");
              this.email_p = true;
            }
            if ( this.item.title == '' ) {
                $(".title-p").css("font-size","14px");
                check = false;
            } else  $(".title-p").css("font-size","0px");
            if ( this.item.desc == '' ) {
                $(".con-p").css("font-size","14px");
                check = false;
            } else  $(".con-p").css("font-size","0px");

           

            if ( this.codevalue == '') {
                this.checkcodeMsg = this.$t('CONTACT.CAPTCHAMSG');
                $(".code-p").css("font-size","14px");
                check = false;
            } else if (this.codevalue.toUpperCase() != this.checkCode) {
                this.checkcodeMsg = this.$t('CONTACT.CAPTCHAERROR');
                $(".code-p").css("font-size","14px");
                check = false;
            } else $(".code-p").css("font-size","0px");
                
            
            if ( check ) {
                vm.Beforesend();
                db.collection(this.$t('DB.CONTACT')).doc(this.id).set(this.item)
                .then((doc) => {
                    alert("成功!");
                    vm.Aftersend();
                    location.reload();
                }).catch((error) => {
                    console.log("Error getting document:", error);
                });

            }   
        },
        createCode(){
            var code = "";    
            var codeLength = 4;
            var random = new Array(0,1,2,3,4,5,6,7,8,9,'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R',   
            'S','T','U','V','W','X','Y','Z'); 
            for(var i = 0; i < codeLength; i++) {  
                var index = Math.floor(Math.random()*36);
                code += random[index];
            }   
                this.checkCode = code;  
        },
        
    }
}
</script>
<style scoped>
.reload i{
  cursor:pointer;
}
.address-box-en p{
  font-size:13px !important;
}
@media (max-width: 960px) { 
  .address-box-en p{
    font-size:12px !important;
  }
}

.input-box-en p{
  font-size:15px !important;
}
.input-box-en input{
  font-size:10px !important;
}
.input-box-en.code{
  width:100% !important;
  flex-direction:column !important;
  padding-top:10px !important;
}
.input-box-en.code div{
  width:100% !important;
}
.input-box-en.code #code{
  width:calc(100% - 110px);
}
.input-box:not(.code):hover{
  border-bottom:  1px solid #003F89 !important;
}
.input-box.code:hover div:first-child{
  border-bottom:  1px solid #003F89 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/index/Contact.vue